import { VisualDataQuery, VisualDataSource } from '../VisualDataSource';
import { VisualDataRequest } from '../VisualDataRequest';

export class RecordVisualDataSource extends VisualDataSource {
  constructor(public readonly rows: ReadonlyArray<Readonly<Record<string, any>>>) {
    super();
  }

  protected queryImpl(request: VisualDataRequest): VisualDataQuery {
    throw new Error(`Not implemented`);
  }
}

